import type { AxiosRequestConfig } from 'axios';
import type { AllAttributeHistory, AttributeHistory } from '@/entities/srm/ci';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

class ValueHistoryApi {
  getAllHistory(options: AxiosRequestConfig = {}) {
    return srmInstance.get(`/value_history`, options);
  }

  getCIHistory(CI_Id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.get<AllAttributeHistory>(
      `/value_history/${CI_Id}`,
      options,
    );
  }

  getAttributeHistory(
    CI_Id: string,
    attribute_id: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<AttributeHistory[]>(
      `/value_history/${CI_Id}/attribute/${attribute_id}`,
      options,
    );
  }
}

export const valueHistoryApi = new ValueHistoryApi();